import { render, staticRenderFns } from "./SplitStatus.vue?vue&type=template&id=7dcd767d&lang=pug"
import script from "./SplitStatus.vue?vue&type=script&lang=js"
export * from "./SplitStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports